import { render, staticRenderFns } from "./RegularEyes.vue?vue&type=template&id=adf4e28e"
import script from "./RegularEyes.vue?vue&type=script&lang=js"
export * from "./RegularEyes.vue?vue&type=script&lang=js"
import style0 from "./RegularEyes.vue?vue&type=style&index=0&id=adf4e28e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports